import { render, staticRenderFns } from "./DirectivesModal.vue?vue&type=template&id=2addac3a&"
import script from "./DirectivesModal.vue?vue&type=script&lang=js&"
export * from "./DirectivesModal.vue?vue&type=script&lang=js&"
import style0 from "./DirectivesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports